module.exports = __webpack_public_path__ + "fonts/soehne-halbfett.9bbcf70.woff2";